import React,{useEffect, useState, useRef} from 'react';
import '../warning/warning.css';
import {IsLSWork} from '../app/app'

function HowToPlay({setHowToPlayGuide, language, hzAdjuster}) {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [clicked, setClicked] = useState(false);
  const wrap = useRef(null);

  let textTranslation = {
    en:{
      tap:"Tap",
      continue:"to continue",
      double:"Double tap",
      speedUp:"to speed up animations",
      topTap:"Tap on top",
      toSee:"to see the menu button"
    },
    ru:{
      tap:"Нажмите",
      continue:"чтобы продолжить",
      double:"Нажмите дважды",
      speedUp:"чтобы ускорить анимации",
      topTap:"Нажмите сверху",
      toSee:"чтобы увидеть кнопку выхода"
    }
  }

  async function go(){

    await goo();


       function goo(){
            return new Promise( async (resolve, reject) => {
              setClicked(false);
              await changeSetting(wrap,"current.style.opacity", 1, "", 0.01);
              setHowToPlayGuide(true);
              if(isLS){
              localStorage.setItem('howToPlayGuideSC', true);
            }
              resolve();
              });
            }

  }

  useEffect(() => {
    start();
    async function start(){
      await changeSetting(wrap,"current.style.opacity", 0, "", 0.01);
      setClicked(true);
    }
},[]);

function changeSetting(obj, setting, changeTo, um, speed, char){
  speed = speed*2*hzAdjuster;
  return new Promise((resolve, reject) => {
    const props = setting
        .split(/[./[\]]/g)
        .filter(p => p);
    const prop = props.pop();
    const parent = props.reduce((result, key) => result[key], obj);
    //
    var i;
    if(setting == "current.style.transform" || setting == "style.transform"){
      i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
    }else{
      i = Math.round(parseFloat(parent[prop]));
    }
    let slowDownTrigger = 0;
  //  if(char){//delete
  //slowDownTrigger = Math.round(parseFloat(Math.abs((char.initialPointX[0]-char.destinationPointX)/char.speed)*0.8));//moment of slower of char
  //}
  //  let slowDownCounter=0;
    let slower = 8;
    change();
  function change(){
    //slowDownCounter++;
  //  if(slowDownCounter > slowDownTrigger && char != undefined){ //delete
  //    slower+=3; //slower of char
  //  }
  //  console.log(slower);

    if(i>changeTo){
      i-=speed;
      if(i<changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
  }else if(i<changeTo){
    i+=speed;
    if(i>changeTo){
      i = changeTo;
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
  }else{
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
    resolve();
    return;
  }
  if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
    parent[prop] = "scale("+i+")";
  }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
    parent[prop] = "rotateY("+i+"deg)";
  }else{
    parent[prop] = i+um;
  }
requestAnimationFrame(change);
return;
}
});
}

return(
<div className='blcwrap'>
<div className='clickWrap' onClick={clicked? go : undefined} id='wrap' ref={wrap} style={{opacity:"1"}}></div>
<div className='txt1'>
<h2 style={{fontSize:"24px", marginTop:"3vh"}}><span style={{color:"#f563f7"}}>{textTranslation[language]["tap"]}</span> {textTranslation[language]["continue"]}</h2>
<h2 style={{fontSize:"24px", marginTop:"1vh"}}><span style={{color:"#f563f7"}}>{textTranslation[language]["double"]}</span> {textTranslation[language]["speedUp"]}</h2>
<h2 style={{fontSize:"24px", marginTop:"1vh"}}><span style={{color:"#f563f7"}}>{textTranslation[language]["topTap"]}</span> {textTranslation[language]["toSee"]}</h2>
<br/>
</div>
</div>
);

}

export default HowToPlay;
